/**
 * Textos del formulario Editar/Nueva célula (mismo copy para administrador, supervisor y líder).
 */
export const CELL_OPTIONAL_PARENT_LINK_LABEL = "Opcional: otra célula de la red";

export const CELL_MEETING_MODALITY_OPTIONS = [
  { value: "presencial", label: "Presencial" },
  { value: "en_linea", label: "En línea" },
  { value: "hibrida", label: "Híbrida (presencial y en línea)" },
];

export const CELL_MEETING_DAY_OPTIONS = [
  { value: "lunes", label: "Lunes" },
  { value: "martes", label: "Martes" },
  { value: "miercoles", label: "Miércoles" },
  { value: "jueves", label: "Jueves" },
  { value: "viernes", label: "Viernes" },
  { value: "sabado", label: "Sábado" },
  { value: "domingo", label: "Domingo" },
];

export const CELL_MEETING_MODALITY_VALUES = CELL_MEETING_MODALITY_OPTIONS.map((o) => o.value);
export const CELL_MEETING_DAY_VALUES = CELL_MEETING_DAY_OPTIONS.map((o) => o.value);

/** Etiqueta corta para badges (p. ej. en Dashboard). */
export const CELL_MEETING_MODALITY_BADGE_LABELS = {
  presencial: "Presencial",
  en_linea: "En línea",
  hibrida: "Híbrida",
};

export function cellMeetingModalityLabel(value, { short = false } = {}) {
  const key = String(value || "").trim().toLowerCase();
  if (!key) return "Sin modalidad";
  if (short) return CELL_MEETING_MODALITY_BADGE_LABELS[key] || key;
  const opt = CELL_MEETING_MODALITY_OPTIONS.find((o) => o.value === key);
  return opt?.label || key;
}

export function cellMeetingDayLabel(value) {
  const key = String(value || "")
    .trim()
    .toLowerCase()
    .replace("é", "e")
    .replace("á", "a")
    .replace("í", "i")
    .replace("ó", "o")
    .replace("ú", "u");
  const opt = CELL_MEETING_DAY_OPTIONS.find((o) => o.value === key);
  return opt?.label || "";
}

export function cellMeetingTimeLabel(value) {
  const s = String(value || "").trim();
  if (!s) return "Sin hora";
  const parts = s.split(":");
  if (parts.length < 2) return s;
  return `${parts[0].padStart(2, "0")}:${parts[1].padStart(2, "0")}`;
}